import { BrowserRouter, Routes, Route } from "react-router-dom";
import Quest from "./pages/Quest.js";
import Results from "./pages/Results.js";

function App({ isLogged, postId, wpNonce, odr, mailTemplate, sourceConversion }) {
  const base_url = process.env.NODE_ENV === 'development' ? process.env.PUBLIC_URL : '/test-habitos-activia';

  return (
    <BrowserRouter>
      <Routes>
        <Route path={`${base_url}/`} element={<Quest />} />
        <Route path={`${base_url}/results`} element={<Results isLogged={isLogged} postId={postId} wpNonce={wpNonce} odr={odr} mailTemplate={mailTemplate} sourceConversion={sourceConversion} />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
